import React, { useEffect, useState } from 'react';
import { withIbge } from '../ibge/ibge.hocs';
import { TextFieldMenuDropdown } from '../../../shared/fields/text-fields/text-field-menu-dropdown/text-field-menu-dropdown';
import { parseIbgeStatesToOptions, parseIbgeCitiesToOptions } from './billing-details-ibge.utils';
import { BILLING_DETAILS_TEXTS, BILLING_DETAILS_TEST_ID } from './billing-details.constants';
import { isDataLoading } from '../../../shared/axios/axios.utils';
import { IbgeState, IbgeCity } from '../ibge/ibge.types';
import { BillingDetails } from './billing-details.types';

interface BillingDetailsIbgeImpl{
    ibgeStates: IbgeState[];
    ibgeCities: IbgeCity[];
    onGetIbgeCities: (string) =>void;
    onChange: Function;
    ibgeCitiesLoadState: string;
    ibgeStatesLoadState:string,
    errors: BillingDetails;
    city: string;
    cityCode: string;
    state: string;
}

const BillingDetailsIbgeImpl = ({
    ibgeStates,
    ibgeCities,
    onGetIbgeCities,
    onChange,
    ibgeCitiesLoadState,
    ibgeStatesLoadState,
    errors,
    cityCode,
    state,
}:BillingDetailsIbgeImpl) => {
    const states = parseIbgeStatesToOptions(ibgeStates);
    const cities = parseIbgeCitiesToOptions(ibgeCities);
    const selectedState = states.find(opt => opt.label === state);

    const [selectedCity, setSelectedCity] = useState(null);

    useEffect(() => {
        setSelectedCity(cities.find(opt => opt.value === parseInt(cityCode, 10)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cityCode]);

    const onChangeState = (option) => {
        onGetIbgeCities(option.value);
        onChange({
            state: option.label,
            stateCode: option.value,
        });
        setSelectedCity(null);
    };

    const onChangeCity = option => onChange({
        city: option.label,
        cityCode: option.value,
    });

    return (
        <>
            <TextFieldMenuDropdown
                onChange={onChangeState}
                options={states}
                label={BILLING_DETAILS_TEXTS.STATE}
                isLoading={isDataLoading(ibgeStatesLoadState)}
                error={errors.state}
                value={selectedState}
                inputId={BILLING_DETAILS_TEST_ID.STATE}
            />
            <TextFieldMenuDropdown
                isLoading={isDataLoading(ibgeCitiesLoadState)}
                options={cities}
                label={BILLING_DETAILS_TEXTS.CITY}
                onChange={onChangeCity}
                error={errors.city}
                inputId={BILLING_DETAILS_TEST_ID.CITY}
                value={selectedCity}
            />
        </>
    );
};

export const BillingDetailsIbge = withIbge(BillingDetailsIbgeImpl);
